import {ColumnConfig, IColumnConfig} from "../../component/table/table-generate/ColumnConfig";
import {generateColumns} from "../../component/table/table-generate/GenerateColumns";
import {COLUMN_KEY} from "./constant";
import {convertCriteriaType} from "../helpers/columns";


const columnTopic: ColumnConfig[] = [
  {
    id: "stt",
    title: "STT",
    classCell: "text-center w-50px",
    classColumn: "w-50px",
  },
  {
    id: "code",
    title: "Mã Danh mục",
    classCell: "text-center",
    classColumn: "align-middle min-w-100px",
  },
  {
    id: "name",
    title: "Tên danh mục",
    classColumn: " align-middle bg-pri min-w-200px",
  },
];

const columnCriteria: ColumnConfig[] = [
  {
    id: "stt",
    title: "STT",
    classCell: "text-center w-50px",
    classColumn: "w-50px",
  },
  {
    id: "code",
    title: "Mã danh mục",
    classCell: "text-center",
    classColumn: "align-middle min-w-100px",
  },
  {
    id: "name",
    title: "Tên danh mục",
    classColumn: "align-middle bg-pri min-w-200px",
  },
  {
    id: "type",
    title: "Loại",
    classColumn: " align-middle bg-pri min-w-200px",
    classCell: "text-center",
  },
];


export const columnCriteriaConfig: IColumnConfig = {
  stt: {
    cellStyle: {
      justifyContent: "center",
    }
  },
  name: {},
  code: {
    cellStyle: {
      justifyContent: "center",
    }
  },
  typeName: {
    cellStyle: {
      justifyContent: "center",
    },
    formatFunc: (value) => convertCriteriaType(value.type)
  },
};

export const columnTopicConfig: IColumnConfig = {
  stt: {
    cellStyle: {
      justifyContent: "center",
    }
  },
  name: {},
  code: {
    cellStyle: {
      justifyContent: "center",
    }
  },
  typeName: {
    cellStyle: {
      justifyContent: "center",
    },
    formatFunc: (value) => convertCriteriaType(value.type)
  },
};


export const columnDM = {
  [COLUMN_KEY.TOPIC]: generateColumns(columnTopic),
  [COLUMN_KEY.CRITERIA]: generateColumns(columnCriteria),
};

export const columnDMConfig = {
  [COLUMN_KEY.TOPIC]: columnTopicConfig,
  [COLUMN_KEY.CRITERIA]: columnCriteriaConfig,
}
